<div class="coupon-page-container">
  <div class="page-header-section">
    <h1>Mis Cupones y Promociones</h1>
    <p class="subtitle">Aquí puedes ver y gestionar todos tus cupones activos.</p>
  </div>

  <div *ngIf="isLoading" class="loading-container">
    <div class="spinner-border text-warning" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
    <p>Cargando tus cupones...</p>
  </div>

  <div *ngIf="error" class="error-container">
    <p class="error-message">{{ error }}</p>
  </div>

  <div *ngIf="!isLoading && !error && coupons.length > 0" class="coupons-grid">
    <ng-container *ngFor="let coupon of coupons">
      <div class="coupon-card" *ngIf="coupon.active">
        <div class="coupon-content">
          <div class="coupon-header">
            <h2 class="coupon-title">{{ coupon.title }}</h2>
            <span class="coupon-status">Activo</span>
          </div>
          <p class="coupon-description">{{ coupon.description }}</p>
          <div class="coupon-details">
            <p class="expiration-date">Expira: {{ coupon.endDate | date:'mediumDate' }}</p>
            <div class="coupon-code-container">
              <span class="coupon-code">{{ coupon.code }}</span>
              <button class="copy-button" (click)="copyCouponCode(coupon.code)">
                <i class="bi bi-clipboard"></i>
                Copiar
              </button>
            </div>
          </div>
          <div class="coupon-actions">
            <p class="share-message">¡Comparte este cupón con tus amigos por WhatsApp para que ellos también aprovechen la promoción!</p>
            <button class="action-button whatsapp" (click)="shareOnWhatsApp(coupon)">
              <i class="bi bi-whatsapp"></i> Enviar por WhatsApp
            </button>
            <button class="action-button share-social" (click)="shareCoupon(coupon)">
              <i class="bi bi-share-fill"></i> Compartir
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div *ngIf="!isLoading && !error && coupons.length === 0" class="no-coupons-container">
    <i class="bi bi-tag no-coupons-icon"></i>
    <p class="no-coupons-message">No tienes cupones disponibles en este momento.</p>
  </div>

</div>